import { useTranslation } from 'react-i18next';

import type { ReturnResolution, ReturnStatus } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const WARNING = 'bg-warning/20 text-warning-foreground border-transparent dark:bg-warning/25';
const SUCCESS = 'bg-success/15 text-success border-transparent dark:bg-success/20';
const NEUTRAL = 'border-border text-muted-foreground';
const INFO = 'bg-primary/10 text-foreground border-transparent';
const DANGER = 'bg-destructive/10 text-destructive border-transparent';

const TONE: Record<ReturnStatus, string> = {
  requested: WARNING,
  approved: INFO,
  in_transit: INFO,
  received: INFO,
  inspected: WARNING,
  resolved: SUCCESS,
  rejected: DANGER,
  cancelled: NEUTRAL,
};

/** Requested and inspected are the loud ones: both wait on staff. */
export function ReturnStatusBadge({
  status,
  className,
}: {
  status: ReturnStatus;
  className?: string;
}) {
  const { t } = useTranslation('returns');
  return (
    <Badge variant="outline" className={cn(TONE[status], className)}>
      {t(`status.${status}`)}
    </Badge>
  );
}

export function ReturnResolutionLabel({ resolution }: { resolution: ReturnResolution | null }) {
  const { t } = useTranslation('returns');
  if (!resolution) return <span className="text-muted-foreground">{t('resolution.none')}</span>;
  return <span>{t(`resolution.${resolution}`)}</span>;
}
